module.exports = __webpack_public_path__ + "static/img/counselor－9.e3688c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/counselor－9.jpg
// module id = uV29
// module chunks = 1